import styled from "@emotion/styled";
import { theme } from "../../styles";

export const ProjectTilesHeaderContainer = styled.div`
  margin-bottom: 80px;

  @media (min-width: ${theme.breakpoints.md}) {
    margin-top: -100px;
    position: relative;
  }

  .ProjectTilesHeader__Title {
    text-transform: uppercase;
    margin: 0;
  }

  .ProjectTilesHeader__Top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;

    @media (max-width: ${theme.breakpoints.xxs}) {
      flex-direction: column;
    }

    > * {
      margin: 0;
    }
  }

  .ProjectTilesHeader__Bottom {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    border-top: 3px solid black;
  }
`;